(function () {
    'use strict';

    angular.module('components.router', [
        'utils',
        'components.config',
        'ui.router'
    ]);
})();